<template>
  <div class="row">
    <div class="col-md-8">
      <edit-profile-form :model="model">
      </edit-profile-form>
    </div>
    <div class="col-md-4">
      <user-card :user="user"></user-card>
    </div>
  </div>
</template>
<script>
  import EditProfileForm from './Profile/EditProfileForm';
  import UserCard from './Profile/UserCard'
  import Api from '../api/api'
  import { API } from '../utils/constants'

  export default {
    components: {
      EditProfileForm,
      UserCard
    },
    data() {
      return {
        model: {
          company: '',
          email: '',
          username: '',
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          country: '',
          about: '',
          phone: ''
        },
        user: {
          fullName: '',
          title: '',
          description: ``,
        }
      }
    },
    mounted () {
    Api.get(API.PROFILE).then(res => {
      console.log(res.data)
      this.model.username =  res.data.user.username;
      this.model.email =  res.data.user.email;
      this.model.firstName =  res.data.user.firstName;
      this.model.lastName =  res.data.user.lastName;
      this.model.address =  res.data.address;
      this.model.about =  res.data.about;
      this.model.city =  res.data.city;
      this.model.country =  res.data.country;
      this.model.phone =  res.data.phoneNumber;

      this.user.fullName = res.data.user.firstName + ' ' + res.data.user.lastName
      this.user.title = res.data.user.email;
      this.user.description = res.data.about;


    });
    }
  }
</script>
<style>
</style>
